import 'reflect-metadata';
import {BehaviorSubject} from 'rxjs';

// export function DoraPropertyArray<T>(doraType: T ) {
//     return (target: any, propertyKey: string | symbol) => {
//         Reflect.defineMetadata('DoraPropertyArray', doraType, target, propertyKey);
//     };
// }

export function DoraPropertyArray(doraType: any ) {
    return (target: any, propertyKey: string | symbol) => {
        Reflect.defineMetadata('DoraPropertyArray', doraType, target, propertyKey);
    };
}

export function DoraProperty(target: any, key: string) {}


export function DoraPropertyDOC(descr: string) {
  console.log('DoraPropertyDOC: ', descr);

  // tslint:disable-next-line:only-arrow-functions
  return function(target: any, key: string) {
    console.log('function: DoraPropertyDOC');
    console.log('target type: ', typeof target);
    console.log('target: ', target);

    // create doraDoc property on Object
    // Object.defineProperty(target.prototype, 'DoraDoc', {
    //   value: descr,
    //   writable: true,
    //   enumerable: true,
    //   configurable: true
    // });

    const accessor = `${key}$`;
    const secret = `_${key}$`;


    Object.defineProperty(target, accessor, {
      get() {
        if (this[secret]) {
          return this[secret];
        }
        this[secret] = new BehaviorSubject(descr);
        return this[secret];
      },
      set() {
        throw new Error('You cannot set this property in the Component if you use @ObservableProperty');
      },
    });

    Object.defineProperty(target, key, {
      get() {
        return this[accessor].getValue();
      },
      set(value: any) {
        this[accessor].next(value);
      },
    });
  };
}
